<template>
  <div
    class="m-market-line"
    :class="{
      'is-super': guide,
      'market-range': presentationType === 8
    }"
  >
    <div class="m-market-line--left">
      <div v-if="label">
        {{ label }}
      </div>
    </div>

    <div
      v-if="marketTitles"
      :class="['m-market-line--right', { 'm-market-line--is-goals': isGoals }]"
    >
      <ul class="flex">
        <li
          v-for="title in marketTitles"
          :key="title"
          class="m-market-title"
        >
          {{ title }}
        </li>
      </ul>

      <svg-icon
        v-if="guide"
        class="help-btn"
        icon-class="icon-help"
        @click="showGuidance"
      />
    </div>
  </div>
</template>

<script>
import modalHelper from '@ms/utils/scroll-fixed'
import { openDialog } from '@ms/ui/dialog'
import { cleanHtml } from '@ms/utils/safe'
import 'base/icons/svg/help.svg'

const GOALS_MARKET_IDS = ['2000021', '2000023', '2000024']

export default {
  name: 'MarketLine',
  props: {
    marketTitles: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ''
    },
    currentMarketId: {
      type: [String, Number],
      default: ''
    },
    // market 布局类型，同比赛详情页
    presentationType: {
      type: Number,
      default: 0
    },
    guide: {
      type: String,
      default: ''
    }
  },
  computed: {
    isGoals() {
      return GOALS_MARKET_IDS.includes(this.currentMarketId)
    }
  },
  methods: {
    showGuidance() {
      let message = this.guide
      const isHtml = /<div|<p|<span/.test(message)
      const classNames = []
      if (isHtml) {
        classNames.push('dialog-market-html')
        message = cleanHtml(message)
      }

      openDialog({
        message,
        classNames,
        closeOnClickModal: true,
        dangerouslyUseHTMLString: isHtml,
        onClose: () => {
          modalHelper.beforeClose()
        }
      })

      modalHelper.afterOpen()
    }
  }
}
</script>

<style lang="scss" scoped>
.m-market-line {
  display: flex;
  height: 24px;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  background: #161616;
  color: #fff;
  line-height: 24px;
}

.m-market-title {
  color: #999;
}

[data-mode="light"] {
  .m-market-line {
    background: #F0F0F0;
    color: #000;
  }

  .m-market-title {
    color: #666;
  }
}
</style>

<style lang="less">
.m-market-line {
  .flex {
    display: flex;
  }

  &.market-range {
    .m-market-title {
      flex: 2;

      &:first-child {
        flex: 1;
        transform: translateX(-50%);
      }

      &:last-child {
        flex: 1;
        transform: translateX(50%);
      }
    }
  }

  &--left {
    flex: 1;
    font-size: 12px;
  }

  &--right {
    position: relative;
    max-width: (208/360) *100%;
    flex: none;
  }

  &--is-goals {
    width: (208/360) *100%;
    max-width: 208px;

    > .flex {
      width: 66.66%;
      max-width: 132px;
      justify-content: space-between;
      margin-left: -2px;
      > .m-market-title { width: fit-content; }
    }
  }

  .m-market-title {
    width: 64px;
    margin-right: 2px;
    font-size: 10px;
    text-align: center;

    &:last-child {
      margin-right: 0;
    }
  }

  .help-btn {
    position: absolute;
    top: 0;
    right: 0;
    margin-top: 4px;
    color: #b2b2b2;
    vertical-align: top;
  }
}

.dialog-market-html {
  .ui-dialog {
    padding-top: 0;

    .ui-dialog--body {
      padding-bottom: 0;

      ul,
      ol,
      li {
        list-style: initial;
      }

      li {
        margin: 10px 0;
      }
    }
  }
}
</style>
